<script lang="ts">
	import type { Snippet } from 'svelte';

	import { m } from '$lib/paraglide/messages.js';
	import { fade } from 'svelte/transition';

	let {
		open = $bindable(false),
		children,
		header,
	}: { open: boolean; children: Snippet; header?: Snippet } = $props();

	$effect(() => {
		if (open) {
			document.documentElement.style.overflow = 'hidden';
		} else {
			document.documentElement.style.removeProperty('overflow');
		}

		return () => {
			document.documentElement.style.removeProperty('overflow');
		};
	});
</script>

{#if open}
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<div
		class="fixed inset-0 top-0 right-0 bottom-0 left-0 z-40 bg-black/60"
		transition:fade={{ duration: 150 }}
		onclick={() => (open = false)}
	></div>
{/if}

<div
	class={[
		'fixed right-0 bottom-0 z-50 flex w-full max-w-screen flex-col rounded-t-2xl md:top-0 md:max-w-1/3',
		'overflow-y-auto bg-white px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))] shadow-xl transition-transform duration-300 ease-in-out md:max-h-full',
		open
			? 'translate-x-0 translate-y-0'
			: 'translate-x-0 translate-y-full md:translate-x-full md:translate-y-0',
	]}
>
	<div class="mb-2 flex items-center justify-between">
		<div class="flex items-center">
			{@render header?.()}
		</div>
		<button
			class="icon-[mdi--window-close] size-9 cursor-pointer transition duration-200 hover:bg-gray-400"
			onclick={() => (open = false)}
			type="button"
			aria-label={m.close()}
		></button>
	</div>
	{@render children()}
</div>
